<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.roleStatus === 1 ? 'light' : 'warning'">
          {{ row.v_roleStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { roleID: row.roleID },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="row.roleStatus === 1"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { roleID: row.roleID },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="allow('C')"
            v-show="row.roleStatus === 1"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="copy(row.roleID)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.roleStatus === 1"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.roleID)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('form_label_recovery') || '恢复'"
            placement="top"
            v-if="allow('R')"
            v-show="row.roleStatus === 0"
          >
            <i
              class="el-icon-refresh tool-btn"
              @click="recovery(row.roleID)"
            ></i>
          </el-tooltip>

          <el-tooltip
            effect="dark"
            :content="$l('btn_text_authUser') || '授权用户'"
            placement="top"
            v-if="allow('U') && row.roleStatus === 1"
          >
            <i
              class="el-icon-finished tool-btn"
              @click="$emit('auth-user', row)"
            />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 170,
          slots: { default: 'opt' },
        },
        {
          title: this.$l('table_label_character_name') || '角色名称',
          field: 'roleName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('table_label_whether_permission') || '是否启用分类权限',
          field: 'v_isUseDataRange',
          width: 150,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_status') || '状态',
          width: 80,
          align: 'center',
          slots: { default: 'status' },
        },
        {
          headerAlign: 'center',
          field: 'createByName',
          title: this.$l('table_label_creator') || '创建人',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          headerAlign: 'center',
          field: 'createDate',
          title: this.$l('table_label_creation_time') || '创建时间',
          align: 'center',
          width: 170,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          headerAlign: 'center',
          field: 'modifyByName',
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          headerAlign: 'center',
          field: 'modifyDate',
          title: this.$l('INDEX.table_label_modification_date') || '修改时间',
          width: 170,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    del(roleID) {
      this.$confirm(
        this.$l('INDEX.form_label_delete_role') || '确认要删除该角色吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        const params = {
          roleID,
          roleStatus: 0,
        }
        this.loadingOpen()
        this.$api
          .sysRoleDelApi(params)
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
            this.saveOkQuestion()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    recovery(roleID) {
      this.$confirm(
        this.$l('INDEX.form_label_restore_role') || '确认要恢复该角色吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        const params = {
          roleID,
          roleStatus: 1,
        }
        this.loadingOpen()
        this.$api
          .sysRoleRecoveryApi(params)
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.form_label_recovery_succeeded') || '恢复成功！',
              type: 'success',
            })
            this.$emit('reload')
            this.saveOkQuestion()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    copy(roleID) {
      this.$confirm(
        this.$l('INDEX.tips_sure_copy_role') || '确认要复制该角色吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .sysRoleCopyApi({ roleID })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.btn_sure_copy_succeeded') || '复制成功',
              type: 'success',
            })
            this.$emit('reload')
            this.saveOkQuestion()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'system-role-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
